/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { MedicalSystemSubCategory } from './MedicalSystemSubCategory';
import {
    MedicalSystemSubCategoryFromJSON,
    MedicalSystemSubCategoryFromJSONTyped,
    MedicalSystemSubCategoryToJSON,
} from './MedicalSystemSubCategory';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { ReferencingObjectDto } from './ReferencingObjectDto';
import {
    ReferencingObjectDtoFromJSON,
    ReferencingObjectDtoFromJSONTyped,
    ReferencingObjectDtoToJSON,
} from './ReferencingObjectDto';
import type { RtSystemCategory } from './RtSystemCategory';
import {
    RtSystemCategoryFromJSON,
    RtSystemCategoryFromJSONTyped,
    RtSystemCategoryToJSON,
} from './RtSystemCategory';
import type { RtSystemManufacturer } from './RtSystemManufacturer';
import {
    RtSystemManufacturerFromJSON,
    RtSystemManufacturerFromJSONTyped,
    RtSystemManufacturerToJSON,
} from './RtSystemManufacturer';
import type { StateOfUse } from './StateOfUse';
import {
    StateOfUseFromJSON,
    StateOfUseFromJSONTyped,
    StateOfUseToJSON,
} from './StateOfUse';
import type { UserCatalogDto } from './UserCatalogDto';
import {
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';

/**
 * 
 * @export
 * @interface ImagingMachineDto
 */
export interface ImagingMachineDto {
    /**
     * 
     * @type {string}
     * @memberof ImagingMachineDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ImagingMachineDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof ImagingMachineDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ImagingMachineDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ImagingMachineDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ImagingMachineDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ImagingMachineDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ImagingMachineDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ImagingMachineDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof ImagingMachineDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof ImagingMachineDto
     */
    readonly possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof ImagingMachineDto
     */
    creatorUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof ImagingMachineDto
     */
    lastModifierUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof ImagingMachineDto
     */
    editingUser?: UserCatalogDto;
    /**
     * 
     * @type {string}
     * @memberof ImagingMachineDto
     */
    editingTime?: string | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof ImagingMachineDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof ImagingMachineDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ImagingMachineDto
     */
    isReferenced?: boolean;
    /**
     * 
     * @type {Array<ReferencingObjectDto>}
     * @memberof ImagingMachineDto
     */
    isReferencedBy?: Array<ReferencingObjectDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ImagingMachineDto
     */
    readonly deleterUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ImagingMachineDto
     */
    readonly deletionTime?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ImagingMachineDto
     */
    readonly isDeleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ImagingMachineDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ImagingMachineDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImagingMachineDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImagingMachineDto
     */
    typeSpecification?: string | null;
    /**
     * 
     * @type {RtSystemCategory}
     * @memberof ImagingMachineDto
     */
    category: RtSystemCategory;
    /**
     * 
     * @type {RtSystemManufacturer}
     * @memberof ImagingMachineDto
     */
    manufacturer: RtSystemManufacturer;
    /**
     * 
     * @type {string}
     * @memberof ImagingMachineDto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof ImagingMachineDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImagingMachineDto
     */
    imageId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ImagingMachineDto
     */
    isArchived?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ImagingMachineDto
     */
    typeId?: string | null;
    /**
     * 
     * @type {MedicalSystemSubCategory}
     * @memberof ImagingMachineDto
     */
    subCategory: MedicalSystemSubCategory;
    /**
     * 
     * @type {StateOfUse}
     * @memberof ImagingMachineDto
     */
    state?: StateOfUse;
    /**
     * 
     * @type {string}
     * @memberof ImagingMachineDto
     */
    serialNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImagingMachineDto
     */
    $type?: ImagingMachineDtoTypeEnum;
}


/**
 * @export
 */
export const ImagingMachineDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMedicalSystemComponentDtoDescriptionsImagingMachineDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.ImagingMachineDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ImagingMachineDtoTypeEnum = typeof ImagingMachineDtoTypeEnum[keyof typeof ImagingMachineDtoTypeEnum];


/**
 * Check if a given object implements the ImagingMachineDto interface.
 */
export function instanceOfImagingMachineDto(value?: unknown): value is ImagingMachineDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ImagingMachineDtoTypeEnum)[0];
}

export function ImagingMachineDtoFromJSON(json: any): ImagingMachineDto {
    return ImagingMachineDtoFromJSONTyped(json, false);
}

export function ImagingMachineDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImagingMachineDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'commentCount': !exists(json, 'commentCount') ? undefined : json['commentCount'],
        'commentAttachmentsCount': !exists(json, 'commentAttachmentsCount') ? undefined : json['commentAttachmentsCount'],
        'lastComment': !exists(json, 'lastComment') ? undefined : json['lastComment'],
        'isAvailable': !exists(json, 'isAvailable') ? undefined : json['isAvailable'],
        'origin': !exists(json, 'origin') ? undefined : EntityOriginFromJSON(json['origin']),
        'possibleActions': !exists(json, 'possibleActions') ? undefined : (json['possibleActions'] === null ? null : (json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        'creatorUser': !exists(json, 'creatorUser') ? undefined : UserCatalogDtoFromJSON(json['creatorUser']),
        'lastModifierUser': !exists(json, 'lastModifierUser') ? undefined : UserCatalogDtoFromJSON(json['lastModifierUser']),
        'editingUser': !exists(json, 'editingUser') ? undefined : UserCatalogDtoFromJSON(json['editingUser']),
        'editingTime': !exists(json, 'editingTime') ? undefined : json['editingTime'],
        'comments': !exists(json, 'comments') ? undefined : (json['comments'] === null ? null : (json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isReferenced': !exists(json, 'isReferenced') ? undefined : json['isReferenced'],
        'isReferencedBy': !exists(json, 'isReferencedBy') ? undefined : (json['isReferencedBy'] === null ? null : (json['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoFromJSON)),
        'deleterUserId': !exists(json, 'deleterUserId') ? undefined : json['deleterUserId'],
        'deletionTime': !exists(json, 'deletionTime') ? undefined : json['deletionTime'],
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
        'name': json['name'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'typeSpecification': !exists(json, 'typeSpecification') ? undefined : json['typeSpecification'],
        'category': RtSystemCategoryFromJSON(json['category']),
        'manufacturer': RtSystemManufacturerFromJSON(json['manufacturer']),
        'model': json['model'],
        'subModel': !exists(json, 'subModel') ? undefined : json['subModel'],
        'imageId': !exists(json, 'imageId') ? undefined : json['imageId'],
        'isArchived': !exists(json, 'isArchived') ? undefined : json['isArchived'],
        'typeId': !exists(json, 'typeId') ? undefined : json['typeId'],
        'subCategory': MedicalSystemSubCategoryFromJSON(json['subCategory']),
        'state': !exists(json, 'state') ? undefined : StateOfUseFromJSON(json['state']),
        'serialNumber': !exists(json, 'serialNumber') ? undefined : json['serialNumber'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function ImagingMachineDtoToJSON(value?: ImagingMachineDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'commentCount': value.commentCount,
        'commentAttachmentsCount': value.commentAttachmentsCount,
        'lastComment': value.lastComment,
        'isAvailable': value.isAvailable,
        'origin': EntityOriginToJSON(value.origin),
        'creatorUser': UserCatalogDtoToJSON(value.creatorUser),
        'lastModifierUser': UserCatalogDtoToJSON(value.lastModifierUser),
        'editingUser': UserCatalogDtoToJSON(value.editingUser),
        'editingTime': value.editingTime,
        'comments': value.comments === undefined ? undefined : (value.comments === null ? null : (value.comments as Array<any>).map(PtwCommentDtoToJSON)),
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isReferenced': value.isReferenced,
        'isReferencedBy': value.isReferencedBy === undefined ? undefined : (value.isReferencedBy === null ? null : (value.isReferencedBy as Array<any>).map(ReferencingObjectDtoToJSON)),
        'name': value.name,
        'iuid': value.iuid,
        'description': value.description,
        'typeSpecification': value.typeSpecification,
        'category': RtSystemCategoryToJSON(value.category),
        'manufacturer': RtSystemManufacturerToJSON(value.manufacturer),
        'model': value.model,
        'subModel': value.subModel,
        'imageId': value.imageId,
        'isArchived': value.isArchived,
        'typeId': value.typeId,
        'subCategory': MedicalSystemSubCategoryToJSON(value.subCategory),
        'state': StateOfUseToJSON(value.state),
        'serialNumber': value.serialNumber,
        '$type': value.$type,
    });
}

